<div class="sorteosLoader loader" *ngIf="loading">
    <img src="assets/images/logo-borde-gris.svg" class="brand-shell loader">
</div>


<div class="historic-main-container" *ngIf="!loading">
    <div class="header-title">
        <h1>Historico de Sorteos</h1>
    </div>

    <!-- EMPTY -->
    <p *ngIf="sorteoHistoryActive.length === 0 && sorteoHistoryFinished.length === 0">
        No puedes ver las participaciones hasta participar en una promo
    </p>

    <!-- ACTIVE SORTEO -->
    <div class="container-my-active" *ngFor="let sorteo of sorteoHistoryActive">
        <div class="header">
            <h2>{{ sorteo.description9 ?? '' }} {{ sorteo.nameSorteo ?? '' }}</h2>
            <p>Activo</p>
        </div>

        <div class="container">
            <div class="container-content">
                <div class="chances">
                    <div class="chances-title">
                        <h2>Participás con:</h2>
                    </div>
                    <div class="chances-content">
                        <img src="assets/images/icon-ticket-red.svg" alt="icon ticket">
                        <p class="number">{{ sorteo.totalChance ?? '' }}</p>
                        <p class="text">Chances</p>
                    </div>
                </div>

                <div class="chances">
                    <div class="chances-title">
                        <h2>Canjeaste:</h2>
                    </div>
                    <div class="chances-content">
                        <img src="assets/images/icon-coin-red.svg" alt="icon coin">
                        <p class="number">{{ sorteo.points | number : '1.0-0'}} </p>
                        <p class="text">Puntos</p>
                    </div>
                </div>

                <div class="chances">
                    <div class="chances-title">
                        <h2>Se sortea el:</h2>
                    </div>
                    <div class="chances-content">
                        <img src="assets/images/icon-calendar-red.svg" alt="icon coin">
                        <p class="number">{{ sorteo.formattedExpirationDate ?? '' }}</p>
                    </div>
                </div>
            </div>

            <div class="actions">
                <div class="actions-content">
                    <p>Ver detalle de tu canje</p>
                    <img src="../../../assets/icon/icon-arrow.svg" alt="icon arrow"
                        (click)="toggleAccordion(sorteo.codeSorteo)"
                        [ngClass]="isSorteoOpen(sorteo.codeSorteo) ? 'open' : 'close'">
                </div>


                <div *ngIf="isSorteoOpen(sorteo.codeSorteo)" class="details">
                    <div class="details-canje" *ngFor="let chance of sorteo.listQuantityChance; last as isLast">
                        <div class="detail-box">
                            <div class="detail">
                                <img src="assets/images/icon-ticket-gray.svg" alt="icon coin">
                                <div class="date">
                                    <p class="chance">{{ chance?.quantityChance ?? '' }} chances</p>
                                    <p class="fecha">{{ chance?.formattedDate ?? '' }}</p>
                                </div>

                            </div>
                            <div class="detail-points">
                                <p class="points">- {{  (sorteo.price * chance.quantityChance) | number : '1.0-0' }} pts</p>
                            </div>
                        </div>

                        <div class="separator" *ngIf="!isLast"></div>
                    </div>
                </div>

                <div class="winners" *ngIf="sorteo.description7">
                    <div class="winners-content">
                        <a class="title">GANADORES:
                            <p class="list" [class.show-all]="showWinners">{{sorteo?.description7}}</p>
                        </a>
                    </div>
                    <button (click)="toggleWinners()" [class.button-bottom]="showWinners">
                        {{ showWinners ? 'ver menos' : 'ver más' }}
                    </button>
                </div>
            </div>
        </div>
    </div>



    <!-- FINISHED SORTEO -->
    <div class="container-my-finished" *ngFor="let sorteo of sorteoHistoryFinished">
        <div class="header">
            <h2>{{ sorteo.description9 ?? '' }} {{ sorteo.nameSorteo ?? '' }}</h2>
            <p>Finalizado</p>
        </div>

        <div class="container-content">
            <div class="chances">
                <div class="chances-title">
                    <h2>Participás con:</h2>
                </div>
                <div class="chances-content">
                    <img src="assets/images/icon-ticket-gray.svg" alt="icon coin">
                    <p class="number"> {{ sorteo.totalChance ?? '' }}</p>
                    <p class="text">Chances</p>
                </div>
            </div>

            <div class="chances">
                <div class="chances-title">
                    <h2>Canjeaste:</h2>
                </div>
                <div class="chances-content">
                    <img src="assets/images/icon-coin-gray.svg" alt="icon coin">
                    <p class="number">{{ sorteo.points | number : '1.0-0' }}</p>
                    <p class="text">Puntos</p>
                </div>
            </div>

            <div class="chances">
                <div class="chances-title">
                    <h2>Se sorteó el:</h2>
                </div>
                <div class="chances-content">
                    <img src="assets/images/icon-calendar-gray.svg" alt="icon coin">
                    <p class="number">{{ sorteo.formattedExpirationDate ?? '' }}</p>
                </div>
            </div>
        </div>


        <div class="actions">
            <div class="actions-content">
                <p>Ver detalle de tu canje</p>
                <img src="../../../assets/icon/icon-arrow.svg" alt="icon arrow"
                    (click)="toggleAccordion(sorteo.codeSorteo)"
                    [ngClass]="isSorteoOpen(sorteo.codeSorteo) ? 'open' : 'close'">
            </div>


            <div *ngIf="isSorteoOpen(sorteo.codeSorteo)" class="details">
                <div class="details-canje" *ngFor="let chance of sorteo.listQuantityChance; last as isLast">
                    <div class="detail-box">
                        <div class="detail">
                            <img src="assets/images/icon-ticket-gray.svg" alt="icon coin">
                            <div class="date">
                                <p class="chance">{{ chance?.quantityChance ?? '' }} chances</p>
                                <p class="fecha">{{ chance?.formattedDate ?? '' }}</p>
                            </div>

                        </div>
                        <div class="detail-points">
                            <p class="points">- {{ (sorteo.price * chance.quantityChance) | number : '1.0-0' }} pts</p>
                        </div>
                    </div>

                    <div class="separator" *ngIf="!isLast"></div>
                </div>
            </div>

            <div class="winners" *ngIf="sorteo.description7">
                <div class="winners-content">
                    <a class="title">GANADORES:
                        <p class="list" [class.show-all]="showWinners">{{sorteo?.description7}}</p>
                    </a>
                </div>
                <button (click)="toggleWinners()" [class.button-bottom]="showWinners">
                    {{ showWinners ? 'ver menos' : 'ver más' }}
                </button>
            </div>
        </div>
    </div>

</div>